import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1495b725"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "escapadoresDisponiveis" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createTextVNode(" Escapadores disponíveis: "),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.escapadores as IEscapador[], (escapador, indice) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass({ usado: _ctx.escapadoresUsados?.includes(escapador) }),
          "aria-label": escapador.toString(),
          key: indice
        }, _toDisplayString(escapador.toString()), 11, _hoisted_2))
      }), 128))
    ])
  ]))
}